module.exports = __webpack_public_path__ + "static/media/Bulldog Face 2c.97ccbdd1.svg";